(() => {
  const userActivityEvents = [
    "mousedown",
    "mousemove",
    "keydown",
    "scroll",
    "touchstart",
    "keypress",
    "touchmove",
  ];
  const SCRIPTS_LOADED_FLAG = "third-party-scripts-loaded";
  let hasReleased = false;

  function readScriptsLoadedFlag() {
    try {
      return localStorage.getItem(SCRIPTS_LOADED_FLAG) === "true";
    } catch (error) {
      return false;
    }
  }

  function writeScriptsLoadedFlag() {
    try {
      localStorage.setItem(SCRIPTS_LOADED_FLAG, "true");
    } catch (error) {
      // Private mode / blocked storage — ignore.
    }
  }

  function markKlaviyoReady() {
    document.documentElement.classList.add("klaviyo-ready");
  }

  function activateLazyScript(scriptTag) {
    return new Promise((resolve) => {
      const lazySrc = scriptTag.dataset.lazySrc;
      if (!lazySrc || scriptTag.getAttribute("src")) {
        resolve();
        return;
      }

      const isKlaviyo = lazySrc.includes("klaviyo");
      const timeoutId = setTimeout(() => {
        if (isKlaviyo) markKlaviyoReady();
        resolve();
      }, 2000);

      const complete = () => {
        clearTimeout(timeoutId);
        if (isKlaviyo) markKlaviyoReady();
        resolve();
      };

      scriptTag.addEventListener("load", complete, { once: true });
      scriptTag.addEventListener("error", complete, { once: true });

      scriptTag.src = lazySrc;
    });
  }

  async function onUserActivity() {
    if (hasReleased) return;
    hasReleased = true;

    for (const event of userActivityEvents) {
      window.removeEventListener(event, onUserActivity);
    }

    // Stop converting newly appended head scripts BEFORE Shopify load handlers run.
    window.__thirdPartyScriptsReleased = true;
    window.dispatchEvent(new CustomEvent("third-party-scripts-release"));
    window.dispatchEvent(new CustomEvent("load-head-scripts"));

    // Allow sync + macrotask appends from load-head-scripts handlers to settle.
    await Promise.resolve();
    await new Promise((resolve) => setTimeout(resolve, 0));

    const scriptTagsForLoad = Array.from(
      document.querySelectorAll("script[data-lazy-src]:not([src])"),
    );

    await Promise.all(scriptTagsForLoad.map(activateLazyScript));

    // Controlled second scan for any late data-lazy-src added during release.
    const strandedScripts = Array.from(
      document.querySelectorAll("script[data-lazy-src]:not([src])"),
    );
    if (strandedScripts.length) {
      await Promise.all(strandedScripts.map(activateLazyScript));
    }

    if (!document.documentElement.classList.contains("klaviyo-ready")) {
      const klaviyoPresent = document.querySelector(
        'script[data-lazy-src*="klaviyo"], script[src*="klaviyo"]',
      );
      if (!klaviyoPresent) {
        markKlaviyoReady();
      }
    }

    writeScriptsLoadedFlag();
    window.dispatchEvent(new CustomEvent("third-party-scripts-loaded"));
    document.documentElement.classList.add("third-party-scripts-loaded");
  }

  function startListenUserActivity() {
    for (const event of userActivityEvents) {
      window.addEventListener(event, onUserActivity, { passive: true });
    }
  }

  window.addEventListener("load", () => {
    if (readScriptsLoadedFlag()) {
      onUserActivity();
    } else {
      startListenUserActivity();
    }
  });
})();
